/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StaffSurveyQuestionAndAnswer = {
    properties: {
        question: {
    type: 'StaffSurveyQuestionForDetails',
    isRequired: true,
},
        answer: {
    type: 'StaffSurveyDataForDetails',
    isRequired: true,
},
    },
};